<!-- 图片上传组件 -->
<style lang="scss" scoped>
.img-upload {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.img-upload-input {
  display: none;
}

.img-upload-empty {
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px dashed $color-primary;
  border-radius: 2px;
  height: 100%;
  text-align: center;
  background: $basic-white;
  cursor: pointer;
}

.img-upload-empty-disabled {
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.img-upload-empty-dragover {
  border-width: 2px;
  background: rgba($color-primary, 0.1);
}

.img-upload-empty-content {
  flex: 1;
}

.img-upload-icon-plus {
  color: $color-primary;
}

.img-upload-empty-text {
  margin-top: 4px;
  padding: 0 10px;
  font-size: 14px;
  color: $darker-text;
  line-height: 16px;
}

.img-upload-preview-container {
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid $base-border;
  border-radius: 2px;
  padding: 10px;
  height: 100%;
  background: $basic-white;
}

.img-upload-preview-img {
  width: 100%;
  height: 100%;
}

.img-upload-preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-upload-preview-zip {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100%;
  cursor: pointer;

  //   .img-upload-icon-zip {
  //     color: $basic-white;
  //   }

  .img-upload-file-name {
    margin-top: 8px;
    font-size: 12px;
    color: $darker-text;
    line-height: 1;

    @include ellipsis(2);
  }
}

.preview-mask-container {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px;
  width: 100%;
  height: 100%;

  &:hover .preview-mask {
    display: flex;
  }
}

.preview-mask {
  display: none;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: $basic-white;
  background: rgba($basic-black, 0.5);
  box-shadow: 0 0 4px rgb(0 0 0 / 10%);
}

.img-upload-preview-icon,
.img-upload-delete-icon {
  cursor: pointer;

  &:hover {
    color: $primary-text-hover;
  }
}

.img-upload-delete-icon {
  margin-left: 20px;
}
</style>

<style lang="scss">
.el-form-item.is-error .img-upload-empty {
  border-color: $primary-text-hover;
  background: $overlay-background;
}
</style>

<template>
  <div class="img-upload">
    <!-- input -->
    <input ref="inputRef" :key="inputKey" type="file" class="img-upload-input" :accept="accept" @change="handleInputChange" />
    <!-- 已上传文件 -->
    <div v-for="(item, index) in filesList" :key="item.id">
      <div v-if="!showPreviewMask" class="mb-1 flex text-[12px]" :style="{ width: `${width}px` }">
        <div class="flex-1 truncate">{{ item.name }}</div>
        <div>
          <span class="ml-1 cursor-pointer text-[var(--el-color-primary)]" @click="onDownload(item)">下载</span>
          <span class="ml-1 cursor-pointer text-[var(--el-color-primary)]" @click="removeFile(item)">删除</span>
        </div>
      </div>
      <div class="img-upload-preview-container" :style="{ height: `${height}px`, width: `${width}px` }">
        <!-- 文件类型 -->
        <div v-if="isZip" class="img-upload-preview-zip">
          <icon class="img-upload-icon-zip" type="yiyuan-icon-zip" :size="iconFileSize" />
          <span class="img-upload-file-name">{{ item.name }}</span>
        </div>
        <!-- 视频类型 -->
        <video v-else-if="isVideo" ref="videoRef" class="img-upload-preview-video" :src="item.url" />
        <el-image v-else :ref="setImageRef" class="img-upload-preview-img" fit="cover" :src="item.url" :preview-src-list="[item.url]" />
        <div v-if="showPreviewMask" class="preview-mask-container">
          <div class="preview-mask">
            <icon
              class="img-upload-preview-icon"
              :type="isZip && !isPdfPreview ? 'yiyuan-download' : 'yiyuan-eye'"
              size="32"
              title="预览"
              @click="preview(item, index)"
            />
            <icon v-if="isPdfPreview" class="img-upload-preview-icon" type="yiyuan-download" size="32" title="下载" @click="onDownload(item)" />
            <icon v-if="isDelete || !disabled" class="img-upload-delete-icon" type="yiyuan-delete" size="32" title="删除" @click="removeFile(item)" />
          </div>
        </div>
      </div>
    </div>
    <!-- 未上传文件 -->
    <div
      v-if="showUploadButton"
      v-loading="uploading"
      class="img-upload-empty"
      :style="{ height: `${height}px`, width: `${width}px` }"
      :class="{
        'img-upload-empty-dragover': dragover,
        'img-upload-empty-disabled': !uploadable,
      }"
      @click="handleClick"
      @drop.prevent="onDrop"
      @dragover.prevent="onDragover"
      @dragleave.prevent="dragover = false"
    >
      <div class="img-upload-empty-content">
        <icon class="img-upload-icon-plus" type="yiyuan-plus" :size="plusSize" />
        <div class="img-upload-empty-text">
          <slot name="empty">
            {{ emptyText }}
          </slot>
        </div>
      </div>
    </div>
  </div>
  <!-- 视频预览 -->
  <PreviewVideoDialog v-if="isVideo" ref="previewVideoDialogRef" />
  <!-- 预览图片组件 -->
  <ImgViewer v-model:visible="showImageViewer" :url-list="previewUrlList" :initial-index="imgViewerIndex" :show-mini-image="true" :z-index="9999" />
</template>

<script setup lang="jsx">
import { ElMessage, ElMessageBox, useFormItem } from 'element-plus'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import ImgViewer from '@/components/img-viewer/img-viewer.vue'
import PreviewVideoDialog from '@/components/preview-video-dialog/preview-video-dialog.vue' // 视频预览组件
import { OSS_DIR } from '@/constants/common'
import { upload } from '@/utils/oss'
import { downloadFile, extractFileNameFromUrl, randomString } from '@/utils/utils'

const NUM = 8
const props = defineProps({
  // 图片的 src，没有图片时为空字符串
  modelValue: {
    type: [Array, String],
    require: true,
  },
  // 未上传文件时的提示文字，也可用 empty slot
  emptyText: {
    type: String,
    default: '点击或拖拽文件至此上传',
  },
  // 是否禁用上传按钮
  disabled: Boolean, // 是否禁用
  // 是否显示删除按钮
  isDelete: {
    type: Boolean,
    default: false,
  },
  // 接受的文件类型
  accept: {
    type: String,
    // https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
    default: 'image/jpeg,image/png',
  },
  isZip: Boolean, // 是否上传文件
  isPdfPreview: Boolean, // pdf文件是否预览
  isVideo: Boolean, // 是否上传视频
  beforeUpload: Function, // 上传前的回调函数, 返回 false 可以阻止上传
  onSuccess: Function, // 上传成功的回调函数
  sizeLimit: Number, // 限制的文件大小，单位为 M
  // 限制文件上传数量
  limit: {
    type: Number,
    default: 1,
  },
  // 宽度
  width: {
    type: [Number, String],
    default: 160,
  },
  // 高度
  height: {
    type: [Number, String],
    default: 100,
  },
  // icon 样式大小
  plusSize: {
    type: Number,
    default: 18,
  },
  // 文件icon大小
  iconFileSize: {
    type: Number,
    default: 28,
  },
  // 上传文件夹
  dir: {
    // required: true,
    type: String,
    validator(dir) {
      const isValid = Object.values(OSS_DIR).some((d) => d === dir)
      if (import.meta.env.DEV && !isValid) {
        const keys = Object.keys(OSS_DIR)
          .map((d) => `OSS_DIR.${d}`)
          .join('、')

        console.error(`[img-upload]dir 属性必须为 ${keys} 其中一个`)
      }
      return isValid
    },
  },
  // 上传按钮显示,详情回现可以隐藏
  showUploadButton: {
    type: Boolean,
    default: true,
  },
  // 是否显示鼠标移入按钮预览
  showPreviewMask: {
    type: Boolean,
    default: true,
  },
})
// data
const dragover = ref(false) // 是否鼠标悬浮
const tempUrl = ref('') // 通过 URL.createObjectURL 创建的临时 url
const uploading = ref(false) // 是否正在上传
const inputKey = ref(0) // input 的 key

const emit = defineEmits(['update:modelValue', 'change'])

// 图片预览组件
const showImageViewer = ref(false)
const imgViewerIndex = ref(0)
// 预览图片url数组
const previewUrlList = computed(() => {
  if (typeof props.modelValue === 'string') {
    if (props.modelValue) {
      return props.modelValue.split(',')
    }
    return []
  } else {
    return props.modelValue
  }
})

// 销毁组件前，回收 url
onBeforeUnmount(() => {
  tempUrl.value && URL.revokeObjectURL(tempUrl.value)
})

// 表单 item
const elFormItem = useFormItem()

// 是否禁用
// const disabled = useDisabled()

// 当前是否可上传
const uploadable = computed(() => !props.disabled && !uploading.value)

// 上传文件地址
const filesList = computed(() => {
  if (!props.modelValue) return
  let tempList = props.modelValue
  // 如果是字符串，转为数组
  if (typeof props.modelValue === 'string') {
    tempList = tempList.split(',')
  }
  const list = tempList.map((url) => {
    // const markIndex = url.lastIndexOf('_') || url.lastIndexOf('/')
    // const lastIndex = markIndex + 1
    // const fileName = decodeURIComponent(url.substring(lastIndex))
    const fileName = extractFileNameFromUrl(url)
    return {
      url,
      name: fileName,
      id: randomString(NUM),
    }
  })
  return list
})

// input 元素的 ref
const inputRef = ref()
// 点击
const handleClick = () => {
  if (props.modelValue && props.modelValue.length >= props.limit) {
    ElMessage.error(`最多可上传${props.limit}个${props.isZip ? '附件' : '文件'}`)
    return
  }
  if (uploadable.value) {
    inputRef.value.click()
  }
}
// 清空 input 的值
const clearFile = () => {
  inputRef.value && (inputRef.value.value = '')
  // IE10 下 input.value = '' 无效，故在此将其重新渲染
  if (inputRef.value?.value) {
    inputKey.value++
  }
}
watch(
  () => props.modelValue,
  (val) => {
    // 触发表单校验
    elFormItem.formItem && elFormItem.formItem.validate('change')
    if (!val) {
      clearFile()
    }
  },
)

// 验证文件
const validateFiles = (files) => {
  if (props.accept) {
    files = [].slice.call(files).filter((file) => {
      const { type, name } = file
      const extension = name.indexOf('.') > -1 ? `.${name.split('.').pop()}` : ''
      const baseType = type.replace(/\/.*$/, '')
      return props.accept
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean)
        .some((acceptedType) => {
          if (/\..+$/.test(acceptedType)) {
            return extension === acceptedType
          }
          if (/\/\*$/.test(acceptedType)) {
            return baseType === acceptedType.replace(/\/\*$/, '')
          }
          if (/^[^/]+\/[^/]+$/.test(acceptedType)) {
            return type === acceptedType
          }
          return false
        })
    })
    if (!files.length) {
      ElMessage.warning('不支持该文件类型')
    }
  }
  if (!files || !files.length) return
  const file = files[0]
  if (props.sizeLimit) {
    const fileSize = file.size / 1024 / 1024
    if (fileSize >= props.sizeLimit) {
      ElMessage.error(props.isZip ? `单个附件不能超过 ${props.sizeLimit}M` : `上传的文件大小不能超过 ${props.sizeLimit}M`)
      clearFile() // 上传完清空,解决重复上传文件不触发change事件
      return
    }
  } else if (typeof props.beforeUpload === 'function' && !props.beforeUpload(file)) {
    return
  }
  return file
}
// 上传文件
const uploadFiles = async (files) => {
  const fileToUpload = validateFiles(files)
  if (!fileToUpload) {
    return
  }
  uploading.value = true
  elFormItem.formItem && elFormItem.formItem.clearValidate()
  try {
    const url = await upload(fileToUpload, props.dir)
    try {
      // onSuccess 可以返回一个 promise，如果返回 promise，上传结果会取决于 promise 最终的状态
      typeof props.onSuccess === 'function' && (await props.onSuccess(url, fileToUpload))
      let fileDataArr = []
      if (props.modelValue && props.modelValue.length > 0) {
        let list = JSON.parse(JSON.stringify(props.modelValue))
        fileDataArr = [...list, url]
      } else {
        fileDataArr = [url]
      }
      emit('update:modelValue', fileDataArr)
      emit('change', fileDataArr)
    } catch (e) {
      // onSuccess 函数报错
    }
  } catch (e) {
    ElMessage.error('上传失败')
  } finally {
    uploading.value = false
    clearFile() // 上传完清空,解决重复上传文件不触发change事件
  }
}
// 点击上传文件
const handleInputChange = (e) => {
  const { files } = e.target
  if (!files || files.length === 0) return
  uploadFiles(files)
}
// 拖拽是鼠标悬浮
const onDragover = () => {
  if (uploadable.value) {
    dragover.value = true
  }
}
// 拖拽释放鼠标
const onDrop = (e) => {
  if (!uploadable.value) return
  dragover.value = false
  uploadFiles(e.dataTransfer.files)
}

let imageRefs = []
// 动态设置el-image组件的ref
const setImageRef = (el) => {
  let srcArr = imageRefs.map((item) => item.src)
  if (el && !srcArr.includes(el.src)) {
    imageRefs.push(el)
  }
}
// 打开图片预览框
const preview = (info, i) => {
  if (props.isZip) {
    window.open(info.url, '_blank')
  } else if (props.isVideo) {
    previewVideo(info)
  } else {
    imgViewerIndex.value = i
    showImageViewer.value = true
    // imageRefs[i].$el.querySelector('img').click()
  }
}
// 下载文件
const onDownload = (info) => {
  downloadFile(info.url, {}, info.name)
}
// 删除文件
const removeFile = (info) => {
  ElMessageBox.confirm('确定要删除吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      clearFile()
      const list = JSON.parse(JSON.stringify(filesList.value))
      const temp = list.filter((item) => item.id !== info.id)
      const tempUrls = temp.map((item) => item.url)
      emit('update:modelValue', tempUrls)
      emit('change', tempUrls)
      ElMessage.success('删除成功')
    })
    .catch(() => {
      // 取消删除
    })
}

const previewVideoDialogRef = ref(null)
// 打开视频预览
const previewVideo = (info) => {
  previewVideoDialogRef.value.init({
    url: info.url,
  })
}
</script>
